module.exports = __webpack_public_path__ + "static/img/mystery-box2-1.404915f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mystery-box2-1.png
// module id = Izks
// module chunks = 215